import React, { useState, useEffect } from "react";
import { ReactComponent as HomeIcon } from "../assets/home.svg";
import { ReactComponent as IngreIcon} from "../assets/ingredient.svg";
import {ReactComponent as RecipesIcon} from "../assets/recipes.svg";
import {ReactComponent as PumpsIcon} from "../assets/pumps.svg";
import { ReactComponent as ReportsIcon} from "../assets/reports.svg";
import { ReactComponent as  ConfigurationsIcon} from "../assets/config.svg";
import {ReactComponent as IconN} from '../assets/threeL.svg';
import BackIcn from '../assets/back_arrow_bg.png';
import Home from "../pages/Home";

const SideBar = ({
    onHomeClick,
    onIngredientsClick,
    onRecipesClick,
    onPumpsClick,
    onReportsClick,
    onConfigurationsClick
}) => {
    const [activeAnchor, setActiveAnchor] = useState("home"); // State to store active anchor tag
    const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
    const [userD, setUserD] = useState(null);
    const [macId, setMachineId] = useState();
    const [macName, setMacName] = useState();
    useEffect(() => {
        const handleResize = () => {
            setSmallMedia(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    // Function to handle click on anchor tags
    const handleAnchorClick = (anchor) => {
        setActiveAnchor(anchor);
        // alert(anchor);
    };
    useEffect(() => {
        const userDataString = sessionStorage.getItem('userData');
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserD(userData);
            // Use userData as needed
        }
    }, []);
    useEffect(() => {
        setMachineId(userD ?.selectedMachineIds);
        setMacName(userD?.selectedName);
    }, [userD]);
    useEffect(() => {
        const activeTab = localStorage.getItem("activeTab");
        setActiveAnchor(activeTab);        
        switch (activeTab) {
            case "recipe":
                setActiveAnchor("recipes");
                break;

            case "ingredient":
                setActiveAnchor("ingredients");
                break;

            case "pumps":
                setActiveAnchor("pumps");
                break;

            case "report":
                setActiveAnchor("reports");
                break;

            case "configuration":
                setActiveAnchor("configurations")
                break;

            default:
                setActiveAnchor('home')
        }
    }, []);
    return (
        <div className="sideBar" style={{display: smallMedia ? "none" : "block"}}>
        <div className="anchor-DD">
            <div className="headText">
                <div className="headSide">
                MAIN NAVIGATION
                </div>
                <div className="lMName" style={{display: macName?.length === 1 ? 'block' : 'none'}}>
                <div  style={{display: macName?.length > 0 ? 'block' : 'none'}}>
                Machine
                </div>
                <div className="macName2">
                {macName?.map((name, index) => (
                    <div key={index}>
                        {name}{index < macName.length - 1 ? ', ' : ''}
                    </div>
                    ))}
                </div>
                </div>
                <div className="framAll">
                <div className="frameA">
                
                    <div className="hom-div">
                        <div className="iconDiv"><HomeIcon className="h-icon" /></div>
                        <div className={`anchorHome ${activeAnchor === "home" ? "active2" : ""} `} ><a href="#"   onClick={(e) => {onHomeClick(); handleAnchorClick("home");}}>Home</a></div>
                    </div>
                    <div className="container-div">
                        <div className="iconDiv"> <IngreIcon className="ing-icon" /></div>
                        <div className={`anchortag ${activeAnchor === "ingredients" ? "active2" : ""}`} ><a href="#"  onClick={(e) => {onIngredientsClick(); handleAnchorClick("ingredients");}}>Ingredients</a> </div>
                    </div>
                    <div className="container-div">
                        <div className="iconDiv"> <RecipesIcon className="rec-icon" /></div>
                        <div className={`anchortag ${activeAnchor === "recipes" ? "active2" : ""}`}><a href="#" onClick={(e) => {onRecipesClick(); handleAnchorClick("recipes");}}>Recipes</a></div>
                    </div>
                    <div className="container-div">
                        <div className="iconDiv"> <PumpsIcon className="pum-icon" /></div>
                        <div className={`anchortag ${activeAnchor === "pumps" ? "active2" : ""}`}><a href="#"  onClick={(e) => {onPumpsClick(); handleAnchorClick("pumps");}}>Pumps</a> </div>
                    </div>
                    <div className="container-div">
                        <div className="iconDiv"> <ReportsIcon className="rep-icon"/> </div>
                        <div className={`anchortag ${activeAnchor === "reports" ? "active2" : ""}`}><a href="#"  onClick={(e) => {onReportsClick(); handleAnchorClick("reports");}}>Reports</a> </div>
                    </div>
                    <div className="container-div">
                        <div className="iconDiv"> <ConfigurationsIcon className="config-icon" /></div>
                        <div className={`anchortag ${activeAnchor === "configurations" ? "active2" : ""}`}><a href="#" onClick={(e) => {onConfigurationsClick(); handleAnchorClick("configurations");}}>Configurations</a> </div>
                    </div>
                    <div className="container-div back-div">
                        <div className="iconDiv bckicn"> 
                        <img src={BackIcn} alt="back icon"/>
                        </div>
                        <div className={`anchortag`}><a onClick={() => localStorage.setItem("activeTab", "home")} href="/details">Back</a> </div>
                    </div>
                </div>
                </div>

                <div className="icon-DD">
                <div className="btn-dd" >
                    <IconN className='sp-icon' />
                </div>  
                </div>
                </div>

                </div>


            {/* </div> */}
        </div>
    );
}

export default SideBar;
